export const SOUNDS_CONFIG = {
  files: {
    notificationSound: "assets/sounds/push.wav",
    sendMessageSound: "assets/sounds/success.wav",
    okSound: "assets/sounds/success.wav",
    errorSound: "assets/sounds/error.wav",
    tickSound: "assets/sounds/tick.wav"
  }
};
